import * as api from "./api";

export interface ClasswizeConfig {
	tenant_key: string;
	classroom_exceptions: Array<string>;
	classroom_groups: Array<string>;
	restricted_groups: Array<string>;
	classroom_allow_owner_access: boolean;
	classroom_restrict_global_teachers: boolean;
	classroom_groups_group_prefix: string;
	classwize_reliever_enabled: boolean;
	teacher_classrooms_enabled: boolean;
	teacher_classrooms_sync_enabled: boolean;
	classroom_reliever_groups: Array<string>;
	classroom_features_enabled: Array<string>;
	classroom_time_restrictions: Array<string>;
	disable_automatic_login: boolean;
	classlink_enabled: boolean;
	classroom_providers: Array<string>;
	enable_support_chatbot: boolean;
	support_chatbot_id: string;
	support_contact_name: string;
	support_contact_email: string;
	support_contact_phone: string;
	support_message: string;
	monitor_groups: Array<string>;
	teachers_stjr_groups: Array<string>;
	teachers_screenshot_history_groups: Array<string>;
	teachers_reporting_groups: Array<string>;
	create_blocking_rules_only: boolean;
	classroom_teachers_allow_reporting_access: boolean;
	teachers_reporting_type: string;
	restrict_classroom_creation_groups: Array<string>;
}

export const getClasswizeConfig = async (options = {}): Promise<ClasswizeConfig> => {
	return (await api.get("/backend/classwize_config", options)) as ClasswizeConfig;
};
